import React from 'react'
import '../CSS/Blogs.css'

function InnerBlogs(props) {
  return (
    <div class="blog-container">
      <div class="blog-card">
        <div class="blog-card-img">
          <img class="blog-img" src={props.imgsrc}/>
        </div>
        <div class="blog-card-content">
            <div class="blog-icon-text">
              <span class="blog-icon" ><i class="ri-user-line"></i></span>
              <span class="blog-text">{props.admin}</span>
          <div class="blog-details">
            <div class="blog-icon-date">
              <span class="blog-icon" ><i class="ri-calendar-line"></i></span>
              <span class="blog-text">{props.date}</span>
            </div>
            </div>
            
          </div>
    
          <h2 class="blog-title">{props.title}</h2>
          <p class="blog-content">
            {props.content}
          </p>
          <hr/>
          <div class="blog">
            <div class="blog-icon-text">
              <span class="blog-icon" ><i class="ri-eye-line"></i></span>
              <span class="blog-text">{props.views}</span>
              <span class="blog-icon" ><i class="ri-message-line"></i></span>
              <span class="blog-text">{props.comments}</span>
            </div>
            <div class="icon-bt">
              <span class="blog-icon" ><i class="ri-heart-line"></i></span>
              <span class="blog-text">{props.likes}</span>
            </div>
          </div>
          
          <div class="blog-cta">
            <a href={props.button_read_more}><button id="blog-btn" class="blog-btn" >Read More</button></a>
            <button class="blog-share-button"><i class="ri-share-line"></i></button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InnerBlogs